<template>
    <div  class="gym-genderselector input-large">
      <select ref="genderSelect">
            <option value = "">{{ $t('register.notAvailable') }}</option>
            <option value = "male">{{ $t('register.male') }}</option>
            <option value = "female">{{ $t('register.female') }}</option>
            <option value = "other">{{ $t('register.other') }}</option>
      </select>
    </div>
  </template>
    
    <script>
    import Choices from 'choices.js'
    //import 'choices.js/public/assets/styles/base.min.css'
    import 'choices.js/public/assets/styles/choices.min.css'
    
export default {
    props: {
    gender: {
      type: String,
      default: '',
    },
  },
  emits: ['update:gender'],
    data() {
    return {
      genderChoices: null
    }
  },
  mounted() {
    this.initChoices();
  },
  watch: {
    gender(newValue) {
      this.updateChoices(newValue);
    }
  },
  methods: {
        initChoices() {
        const { genderSelect } = this.$refs;

        if (this.genderChoices) {
            this.genderChoices.destroy();
        }

        this.genderChoices = new Choices(genderSelect, {
            placeholder: true,
            placeholderValue: this.$t('register.notAvailable'),
            shouldSort: false,
            allowHTML: true,
            searchEnabled: false,
            removeItemButton: false,
            itemSelectText: this.$_locale('choicesjs.itemSelectText'),
        });

        if (this.gender) {
            this.genderChoices.setChoiceByValue(this.gender);
        }

        genderSelect.addEventListener('change', (e) => {
            this.$emit('update:gender', e.target.value);
        });
        },

        updateChoices(newValue) {
        if (this.genderChoices) {
            this.genderChoices.destroy();
        }
        this.initChoices();
            if (newValue) {
                this.genderChoices.setChoiceByValue(newValue);
            }
        }
    }
}
    </script>
    
    <style scoped>
    .gym-genderselector {
        margin: var(--wn-space-5) 0 var(--wn-space-4) 0;
    }
    </style>